module.exports = __webpack_public_path__ + "img/wechat.a42343e0.svg";